// SINGLE SOURCE OF TRUTH for coloring financial values across CHEKSTE.
// Principle: RED is reserved for genuinely bad/negative. Positive-but-weak = AMBER.
// Positive-and-strong = GREEN. Consistent by construction across all strategies
// (Rental cash flow, Property-Value equity, Fix & Flip profit/margin) so the rule
// can't drift per-component (same one-source lesson as the unified comp count).

export function financialSign(value, band = 0) {
  const v = Number(value) || 0;
  return v > band ? 'positive' : v < -band ? 'negative' : 'neutral';
}

// Sign-based TEXT color (cash flow, equity, net profit): positive=green,
// negative=red, ~zero=neutral.
export function financialTextColor(value, band = 0) {
  const s = financialSign(value, band);
  return s === 'positive' ? 'text-green-600' : s === 'negative' ? 'text-red-600' : 'text-slate-500';
}

// Sign-based CARD color set (bg + border + text + indicator dot) — e.g. the equity card.
export function financialCardColor(value, band = 0) {
  const s = financialSign(value, band);
  if (s === 'positive') return { bg: 'bg-green-50', border: 'border-green-200', text: 'text-green-700', indicator: 'bg-green-500' };
  if (s === 'negative') return { bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-700', indicator: 'bg-red-500' };
  return { bg: 'bg-slate-50', border: 'border-slate-200', text: 'text-slate-700', indicator: 'bg-slate-400' };
}

// TIERED strength color for quality metrics (margin, cap rate): strong positive=green,
// thin-but-positive=AMBER (caution — NEVER red), negative/zero=red. Option B: red is
// never used for a positive value.
export function tierTextColor(value, strongThreshold) {
  const v = Number(value) || 0;
  if (v >= strongThreshold) return 'text-green-600';
  if (v > 0) return 'text-amber-600';
  return 'text-red-600';
}
